import { USStateObject } from '../../../constants/USstates/constants';
import { DEFAULT_US_STATE, US_STATES } from '../../../constants/USstates/states';

export const SearchStateFromList = (searchValue: string): USStateObject[] => {
  return (
    US_STATES.filter(state => {
      const lowerCaseName = state.stateName.toLowerCase();
      return lowerCaseName.includes(searchValue);
    }) || [DEFAULT_US_STATE]
  );
};
